<template>
  <v-tooltip bottom :disabled="!computedTooltip">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" :color="computedColor" :size="size">
        {{ computedIcon }}
      </v-icon>
    </template>
    <span>{{ computedTooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "boolean-icon",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    trueIcon: {
      type: String,
      default: "mdi-check",
    },
    falseIcon: {
      type: String,
      default: "mdi-close",
    },
    trueColor: {
      type: String,
      default: "green",
    },
    falseColor: {
      type: String,
      default: "red",
    },
    trueTooltip: {
      type: String,
      default: "",
    },
    falseTooltip: {
      type: String,
      default: "",
    },
    size: {
      type: [String, Number],
      default: 24,
    },
  },
  computed: {
    computedIcon() {
      return this.value ? this.trueIcon : this.falseIcon;
    },
    computedColor() {
      return this.value ? this.trueColor : this.falseColor;
    },
    computedTooltip() {
      return this.value ? this.trueTooltip : this.falseTooltip;
    },
  },
};
</script>

<style scoped></style>
